// extracted by mini-css-extract-plugin
module.exports = {"cont-awards":"cont-awards","contAwards":"cont-awards"};